import { LiveEndpoints } from './liveEndpoints'

import { Transmission, Visibility } from 'modules/transmission/types'
import request from 'core/config/request'

export class LiveService {
  static getLive = async (transmissionCode: string, visibility: Visibility) => {
    const options = visibility === Visibility.PUBLIC
      ? { headers: { Authorization: '' } }
      : {}

    const { data } = await request.get<Transmission>(
      LiveEndpoints.getLive(transmissionCode, visibility),
      options
    )

    return data
  }
}
